<template>
  <div class="container-goods">
    <div class="container-goods__header">
      <span class="container-goods__title">
        {{ $l('section_goods_detail') || '产品明细' }}
        <span class="container-goods__count">
          ({{ displayData.length }}{{ $l('label_item_count') || '项' }})
        </span>
      </span>
    </div>

    <vxe-grid
      ref="table"
      size="small"
      row-id="shipmentContainerGoodsCode"
      border
      resizable
      auto-resize
      highlight-hover-row
      show-overflow
      :height="200"
      :data="displayData"
      :columns="tableColumns"
      :scroll-y="{ enabled: true, gt: 0 }"
    >
      <template #hscodeHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_hscode') || '报关HSCODE'"
          :items="options.hscode"
          @filter="(e) => (appliedFilters.hscode = e)"
          submitFilterOnClose
        />
        <span v-else>{{ $l('table_label_hscode') || '报关HSCODE' }}</span>
      </template>
      <template #hscodeNameHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_hscodeName') || '报关中文品名'"
          :items="options.hscodeName"
          @filter="(e) => (appliedFilters.hscodeName = e)"
          submitFilterOnClose
        />
        <span v-else>{{ $l('table_label_hscodeName') || '报关中文品名' }}</span>
      </template>
      <template #hscodeNameEnHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_hscodeNameEn') || '报关英文品名'"
          :items="options.hscodeNameEn"
          @filter="(e) => (appliedFilters.hscodeNameEn = e)"
          submitFilterOnClose
        />
        <span v-else>{{
          $l('table_label_hscodeNameEn') || '报关英文品名'
        }}</span>
      </template>
      <template #originalPlaceHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_originalPlace') || '境内货源地'"
          :items="options.originalPlace"
          @filter="(e) => (appliedFilters.originalPlace = e)"
          submitFilterOnClose
        />
        <span v-else>{{
          $l('table_label_originalPlace') || '境内货源地'
        }}</span>
      </template>
      <template #amzSkuNoHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_sku') || 'SKU'"
          :items="options.amzSkuNo"
          @filter="(e) => (appliedFilters.amzSkuNo = e)"
          submitFilterOnClose
        />
        <span v-else>{{ $l('table_label_sku') || 'SKU' }}</span>
      </template>
      <template #amzStoreSkuNoHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_storeSku') || '店铺 SKU'"
          :items="options.amzStoreSkuNo"
          @filter="(e) => (appliedFilters.amzStoreSkuNo = e)"
          submitFilterOnClose
        />
        <span v-else>{{ $l('table_label_storeSku') || '店铺 SKU' }}</span>
      </template>
      <template #goodsNameHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_goodsName') || '产品名称'"
          :items="options.goodsName"
          @filter="(e) => (appliedFilters.goodsName = e)"
          submitFilterOnClose
        />
        <span v-else>{{ $l('table_label_goodsName') || '产品名称' }}</span>
      </template>
      <template #goodsColorHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_goodsColor') || '颜色'"
          :items="options.goodsColor"
          @filter="(e) => (appliedFilters.goodsColor = e)"
          submitFilterOnClose
        />
        <span v-else>{{ $l('table_label_goodsColor') || '颜色' }}</span>
      </template>
      <template #ncNoHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_ncNo') || 'NC编号'"
          :items="options.ncNo"
          @filter="(e) => (appliedFilters.ncNo = e)"
          submitFilterOnClose
        />
        <span v-else>{{ $l('table_label_ncNo') || 'NC编号' }}</span>
      </template>
      <template #storeNameHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_storeName') || '店铺名称'"
          :items="options.storeName"
          @filter="(e) => (appliedFilters.storeName = e)"
          submitFilterOnClose
        />
        <span v-else>{{ $l('table_label_storeName') || '店铺名称' }}</span>
      </template>
      <template #amzReplenishmentNoHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_amzReplenishmentNo') || '补货单号'"
          :items="options.amzReplenishmentNo"
          @filter="(e) => (appliedFilters.amzReplenishmentNo = e)"
          submitFilterOnClose
        />
        <span v-else>{{
          $l('table_label_amzReplenishmentNo') || '补货单号'
        }}</span>
      </template>
      <template #planNoHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('form_label_planNos') || '补货计划编号'"
          :items="options.planNo"
          @filter="(e) => (appliedFilters.planNo = e)"
          submitFilterOnClose
        />
        <span v-else>{{
          $l('form_label_planNos') || '补货计划编号'
        }}</span>
      </template>
      <template #fbaDcHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_fbaDc') || 'FBA DC'"
          :items="options.fbaDc"
          @filter="(e) => (appliedFilters.fbaDc = e)"
          submitFilterOnClose
        />
        <span v-else>{{ $l('table_label_fbaDc') || 'FBA DC' }}</span>
      </template>
      <template #fbaIdHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_fbaId') || 'FBA ID'"
          :items="options.fbaId"
          @filter="(e) => (appliedFilters.fbaId = e)"
          submitFilterOnClose
        />
        <span v-else>{{ $l('table_label_fbaId') || 'FBA ID' }}</span>
      </template>
      <template #fbaIdReferenceIdHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_fbaIdReferenceId') || 'FBA Reference ID'"
          :items="options.fbaIdReferenceId"
          @filter="(e) => (appliedFilters.fbaIdReferenceId = e)"
          submitFilterOnClose
        />
        <span v-else>{{
          $l('table_label_fbaIdReferenceId') || 'FBA Reference ID'
        }}</span>
      </template>
      <template #goodsSizeHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_goodsSize') || '规格/尺寸'"
          :items="options.goodsSize"
          @filter="(e) => (appliedFilters.goodsSize = e)"
          submitFilterOnClose
        />
        <span v-else>{{ $l('table_label_goodsSize') || '规格/尺寸' }}</span>
      </template>
      <template #materialInfoHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_materialInfo') || '产品材质'"
          :items="options.materialInfo"
          @filter="(e) => (appliedFilters.materialInfo = e)"
          submitFilterOnClose
        />
        <span v-else>{{ $l('table_label_materialInfo') || '产品材质' }}</span>
      </template>
      <template #goodsReadyDateHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_goodsReadyDate') || '货好时间'"
          :items="options.goodsReadyDate"
          @filter="(e) => (appliedFilters.goodsReadyDate = e)"
          submitFilterOnClose
        />
        <span v-else>{{ $l('table_label_goodsReadyDate') || '货好时间' }}</span>
      </template>
      <template #customerDeliveryDateHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_customerDeliveryDate') || '客户交期'"
          :items="options.customerDeliveryDate"
          @filter="(e) => (appliedFilters.customerDeliveryDate = e)"
          submitFilterOnClose
        />
        <span v-else>{{
          $l('table_label_customerDeliveryDate') || '客户交期'
        }}</span>
      </template>
      <template #loadingDateHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_loadingDate') || '产装日期'"
          :items="options.loadingDate"
          @filter="(e) => (appliedFilters.loadingDate = e)"
          submitFilterOnClose
        />
        <span v-else>{{ $l('table_label_loadingDate') || '产装日期' }}</span>
      </template>
      <template #scmNameHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_scmName') || '出货工厂'"
          :items="options.scmName"
          @filter="(e) => (appliedFilters.scmName = e)"
          submitFilterOnClose
        />
        <span v-else>{{ $l('table_label_scmName') || '出货工厂' }}</span>
      </template>
      <template #ecomWarehouseNameHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_ecomWarehouseName') || '出货仓库'"
          :items="options.ecomWarehouseName"
          @filter="(e) => (appliedFilters.ecomWarehouseName = e)"
          submitFilterOnClose
        />
        <span v-else>{{
          $l('table_label_ecomWarehouseName') || '出货仓库'
        }}</span>
      </template>
      <template #invoiceFactoryNameHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_invoiceFactoryName') || '开票工厂'"
          :items="options.invoiceFactoryName"
          @filter="(e) => (appliedFilters.invoiceFactoryName = e)"
          submitFilterOnClose
        />
        <span v-else>{{
          $l('table_label_invoiceFactoryName') || '开票工厂'
        }}</span>
      </template>
      <template #shippingFactoryNameHeader>
        <filter-content
          v-if="filterEnabled"
          :text="$l('table_label_shippingFactoryName') || '送货工厂'"
          :items="options.shippingFactoryName"
          @filter="(e) => (appliedFilters.shippingFactoryName = e)"
          submitFilterOnClose
        />
        <span v-else>{{
          $l('table_label_shippingFactoryName') || '送货工厂'
        }}</span>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import {
  applyTableFilters,
  buildFilterOptions,
  createEmptyFilters,
  normalizeFilterValues,
} from '../table-filter-helpers'
import tableColumns from './table-columns'

const FILTER_FIELDS = [
  'amzSkuNo',
  'amzStoreSkuNo',
  'goodsName',
  'goodsColor',
  'ncNo',
  'storeName',
  'amzReplenishmentNo',
  'planNo',
  'fbaDc',
  'fbaId',
  'fbaIdReferenceId',
  'goodsSize',
  'materialInfo',
  'goodsReadyDate',
  'customerDeliveryDate',
  'loadingDate',
  'scmName',
  'ecomWarehouseName',
  'invoiceFactoryName',
  'shippingFactoryName',
  'hscode',
  'hscodeName',
  'hscodeNameEn',
  'originalPlace',
]

export default {
  props: { tableData: { type: Array, default: () => [] } },
  data() {
    return {
      filterEnabled: false,
      filterEnableTimer: null,
      appliedFilters: createEmptyFilters(FILTER_FIELDS),
      options: createEmptyFilters(FILTER_FIELDS),
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    displayData() {
      if (!this.filterEnabled) return this.tableData

      return applyTableFilters(this.tableData, this.appliedFilters, this.options)
    },
  },
  watch: {
    tableData() {
      if (!this.filterEnabled) {
        this.scheduleFilterEnable()
        return
      }
      this.buildOptions()
    },
  },
  mounted() {
    this.scheduleFilterEnable()
  },
  beforeDestroy() {
    if (this.filterEnableTimer) {
      clearTimeout(this.filterEnableTimer)
      this.filterEnableTimer = null
    }
  },
  methods: {
    scheduleFilterEnable() {
      if (this.filterEnabled || this.filterEnableTimer) return

      this.$nextTick(() => {
        this.filterEnableTimer = setTimeout(() => {
          this.filterEnableTimer = null
          if (this.filterEnabled) return

          this.filterEnabled = true
          this.buildOptions()
        }, 0)
      })
    },
    buildOptions() {
      this.options = buildFilterOptions(this.tableData, FILTER_FIELDS)
      this.normalizeAppliedFilters()
    },
    normalizeAppliedFilters() {
      this.appliedFilters = normalizeFilterValues(
        this.appliedFilters,
        this.options
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.container-goods__header {
  margin-bottom: 8px;
}

.container-goods__title {
  font-size: 12px;
  font-weight: 600;
  color: #334155;
}

.container-goods__count {
  margin-left: 4px;
  font-weight: 400;
  color: #94a3b8;
}
</style>
